"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("@/api/class/ApiData"));
const litigationApi = {
    litigationContractList: new ApiData_1.default({
        name: '待诉合同',
        url: 'web/cs-overdue-record/toLitigationPageList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationContractExport: new ApiData_1.default({
        name: '待诉合同导出',
        url: 'web/cs-overdue-record/toLitigationExport',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationApplicationList: new ApiData_1.default({
        name: '诉讼申请列表',
        url: 'web/cs-apply-litigation/pageList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationApplicationBuild: new ApiData_1.default({
        name: '诉讼申请新增',
        url: 'web/cs-apply-litigation/apply',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationApplicationInfo: new ApiData_1.default({
        name: '诉讼申请详情',
        url: 'web/cs-apply-litigation/detail',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    litigationApplicationChange: new ApiData_1.default({
        name: '诉讼申请审批',
        url: 'web/cs-apply-litigation/submit',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationApplicationReject: new ApiData_1.default({
        name: '诉讼申请驳回',
        url: 'web/cs-apply-litigation/reject',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationApplicationRefuse: new ApiData_1.default({
        name: '诉讼申请拒绝',
        url: 'web/cs-apply-litigation/refuse',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationLogList: new ApiData_1.default({
        name: '诉讼记录列表',
        url: 'web/csLitigationRecord/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationLogExport: new ApiData_1.default({
        name: '诉讼记录导出',
        url: 'web/csLitigationRecord/export',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationLogBuild: new ApiData_1.default({
        name: '诉讼记录新增',
        url: 'web/csLitigationRecord/add',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationLogChange: new ApiData_1.default({
        name: '诉讼记录修改',
        url: 'web/csLitigationRecord/update',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationLogInfo: new ApiData_1.default({
        name: '诉讼记录修改',
        url: 'web/csLitigationRecord/info',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    litigationCollectionList: new ApiData_1.default({
        name: '法诉回款列表',
        url: 'web/csLitigationCollectionInfo/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationCollectionBuild: new ApiData_1.default({
        name: '法诉回款新增',
        url: 'web/csLitigationCollectionInfo/add',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationCollectionChange: new ApiData_1.default({
        name: '法诉回款修改',
        url: 'web/csLitigationCollectionInfo/update',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationCollectionDelete: new ApiData_1.default({
        name: '法诉回款删除',
        url: 'web/csLitigationCollectionInfo/deletes',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationAuctionList: new ApiData_1.default({
        name: '评估拍卖列表',
        url: 'web/csLitigationAuctionDetail/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationAuctionBuild: new ApiData_1.default({
        name: '评估拍卖新增',
        url: 'web/csLitigationAuctionDetail/add',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationAuctionChange: new ApiData_1.default({
        name: '评估拍卖修改',
        url: 'web/csLitigationAuctionDetail/update',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationAuctionDict: new ApiData_1.default({
        name: '评估拍卖字典',
        url: 'web/csLitigationAuctionDetail/getAuctionTypeDict',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    litigationAuctionNext: new ApiData_1.default({
        name: '评估拍卖下一步',
        url: 'web/csLitigationAuctionDetail/geNextAuctionType',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    litigationExecute: new ApiData_1.default({
        name: '法诉执行申请列表',
        url: 'web/csApplyLitigationExecute/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationExecuteInfo: new ApiData_1.default({
        name: '法诉执行申请详情',
        url: 'web/csApplyLitigationExecute/info',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    // litigationExecuteBuild: new ApiData<[Record<string, unknown>], responseType>({
    //   name: '法诉执行申请新增',
    //   url: 'web/csApplyLitigationExecute/apply',
    //   urlConfig: {
    //     pre: '',
    //     service: 'ufo/cs/'
    //   },
    //   method: 'post',
    //   data: ['inherit']
    // }),
    litigationExecuteChange: new ApiData_1.default({
        name: '法诉执行申请修改',
        url: 'web/csApplyLitigationExecute/submit',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationExecuteRefuse: new ApiData_1.default({
        name: '法诉执行申请拒绝',
        url: 'web/csApplyLitigationExecute/refuse',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationExecuteReject: new ApiData_1.default({
        name: '法诉执行申请驳回',
        url: 'web/csApplyLitigationExecute/reject',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationSeize: new ApiData_1.default({
        name: '法诉查封申请列表',
        url: 'web/csApplyLitigationSeize/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationSeizeInfo: new ApiData_1.default({
        name: '法诉查封申请详情',
        url: 'web/csApplyLitigationSeize/info',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    litigationSeizeBuild: new ApiData_1.default({
        name: '法诉查封申请新增',
        url: 'web/csApplyLitigationSeize/apply',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationSeizeChange: new ApiData_1.default({
        name: '法诉查封申请修改',
        url: 'web/csApplyLitigationSeize/submit',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationSeizeRefuse: new ApiData_1.default({
        name: '法诉查封申请拒绝',
        url: 'web/csApplyLitigationSeize/refuse',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationSeizeReject: new ApiData_1.default({
        name: '法诉查封申请驳回',
        url: 'web/csApplyLitigationSeize/reject',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationMediateList: new ApiData_1.default({
        name: '法诉调解列表',
        url: 'web/csLitigationMediateDetail/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationMediateBuild: new ApiData_1.default({
        name: '法诉调解新增',
        url: 'web/csLitigationMediateDetail/add',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationMediateChange: new ApiData_1.default({
        name: '法诉调解修改',
        url: 'web/csLitigationMediateDetail/update',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    litigationMediateInfo: new ApiData_1.default({
        name: '法诉调解详情',
        url: 'web/csLitigationMediateDetail/info',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
};
exports.default = litigationApi;
